//React component for the "StationsPage" page i.e. the big page that lists all of the news stations
import StationsPageTableAdvanced from './StationsPageTableAdvanced.js';
import { Grid2 } from '@mui/material';
import HeaderBar from '../Shared/HeaderBar/HeaderBar.js';
import NavigationBar from "../Shared/NavigationBar/NavigationBar.js"

export default function DevStationsPage(){


    return (
        <>
            <HeaderBar page={"StationsPage"} ></HeaderBar>
                <Grid2 container={true} justifyContent={'center'} alignItems={'center'} direction={'column'} id={"StationsPageAdvancedGrid"} paddingBottom={'5em'}>
                    <StationsPageTableAdvanced></StationsPageTableAdvanced>
                </Grid2>
            <NavigationBar></NavigationBar>
        </>
    )
}
